import type { Entity } from '@platform/entities/entity.class';
import type { FormFieldParams } from './types';
import type {
    FabricRule,
    FabricRuleProps,
    PredefinedRule,
} from '@platform/components/docflow/common/form-generator/form-rules';
import { predefined } from '@platform/components/docflow/common/form-generator/form-rules';

export function FormField(params: FormFieldParams) {
    return function (target: Entity, key: string) {
        const con = target.constructor as typeof Entity;
        if (!Object.prototype.hasOwnProperty.call(con, '_formFields')) {
            con._formFields = {};
        }
        if (!con._formFields) con._formFields = {};
        con._formFields[key] = params;
    };
}

type EntityDecorator = (target: Entity, key: string) => void;

function WithValidation(rule: PredefinedRule, props?: undefined): EntityDecorator;
function WithValidation<T extends FabricRule>(rule: T, props: FabricRuleProps<T>): EntityDecorator {
    return function (target: Entity, key: string) {
        const con = target.constructor as typeof Entity;
        if (!Object.prototype.hasOwnProperty.call(con, '_formFields')) {
            console.warn(`Validation can be applied only to FormFiled (property ${key} of ${con.name})`);
            return;
        }
        if (!con._formFields[key].rules) con._formFields[key].rules = [];
        con._formFields[key].rules?.push(rule in predefined ? rule : { type: rule, ...props });
    };
}

export { WithValidation };

export function BindProp(prop: string, value: (item: any) => any) {
    return function (target: Entity, key: string) {
        const con = target.constructor as typeof Entity;
        if (!Object.prototype.hasOwnProperty.call(con, '_formFields')) {
            console.warn(`Bound prop can be applied only to FormFiled (property ${key} of ${con.name})`);
            return;
        }
        if (!con._formFields[key].boundProps) con._formFields[key].boundProps = {};

        // @ts-ignore
        con._formFields[key].boundProps[prop] = value;
    };
}
